// extracted by mini-css-extract-plugin
export default {"root":"Header-root","impersonationHeight":"Header-impersonationHeight","oneAppHeader":"Header-oneAppHeader","impersonation":"Header-impersonation"};